import { type FC } from 'react';

import { Link } from 'react-router-dom';

import { COMPANY } from '@shared/config';

// Согласие — отдельный документ (ч. 1 ст. 9 152-ФЗ, с 01.09.2025). Один текст для /consent и окна из формы.
// При правке — поднять PD_DOCS_VERSION
export const ConsentText: FC = () => (
  <>
    <p>
      Отмечая согласие в форме запроса коммерческого предложения на сайте {COMPANY.site}, я
      свободно, своей волей и в своём интересе даю согласие{' '}
      <strong>{COMPANY.operatorDative}</strong> (ОГРНИП {COMPANY.ogrnip}, ИНН {COMPANY.inn}, адрес:{' '}
      {COMPANY.address}) на обработку моих персональных данных на следующих условиях.
    </p>

    <h2>Данные</h2>
    <p>
      Имя, наименование организации, номер телефона или адрес электронной почты, текст обращения и
      сведения в приложенных к нему файлах — в объёме, который я указал в форме.
    </p>

    <h2>Цели</h2>
    <p>Рассмотрение моего запроса, подготовка коммерческого предложения и связь со мной по нему.</p>

    <h2>Действия и способы</h2>
    <p>
      Сбор, запись, систематизация, накопление, хранение, уточнение, использование, удаление и
      уничтожение — с использованием средств автоматизации и без них.
    </p>

    <h2>Срок и отзыв</h2>
    <p>
      Согласие действует до достижения целей обработки, но не дольше 3 лет, либо до его отзыва.
      Отозвать согласие можно письмом на <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a> или
      по адресу: {COMPANY.address}.
    </p>

    <p>
      Подробнее — в <Link to="/privacy">Политике обработки персональных данных</Link>.
    </p>
  </>
);
